module.exports = __webpack_public_path__ + "static/img/tu.80f55cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/tu.png
// module id = AxZN
// module chunks = 1